import { render } from "./AddExercise.vue?vue&type=template&id=cadd8bf6"
import script from "./AddExercise.vue?vue&type=script&lang=js"
export * from "./AddExercise.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__